export default "__VITE_ASSET__BqTBQVkm__"